package floris.graphics.landing.pages.projects.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.components.text.SpanText
import floris.graphics.models.domain.models.Contributor
import org.jetbrains.compose.web.css.px

@Composable
fun ContributorRow(
    modifier: Modifier = Modifier,
    labelText: String,
    contributor: Contributor?
) {
    if (contributor == null) return

    Row(
        modifier = modifier
    ) {
        SpanText(
            modifier = Modifier // TODO: modify the color so it's not the eye catcher?
                .fontSize(16.px)
                .lineHeight(22.px)
                .margin(right = 10.px)
                .fontWeight(FontWeight.Bold),
            text = labelText
        )

        SpanText(
            modifier = Modifier, // TODO: modify the color so it's not the eye catcher?
            text = contributor.name
        )
    }
}